import OHIF from 'ohif-core';
import updateTableWithNewMeasurementData from './lib/updateTableWithNewMeasurementData';
import {
  setLabellingFlowDataAction,
  setToolContextMenuDataAction,
  resetLabellingAndContextMenuAction,
  setImageContextDataAction,
} from './store';

// import cornerstoneTools from 'cornerstone-tools';

// let tagsStatus = false;
function getToolLabellingFlowCallback(store) {
  const setLabellingFlowData = labellingFlowData => {
    store.dispatch(setLabellingFlowDataAction(labellingFlowData));
  };

  return function toolLabellingFlowCallback(
    measurementData,
    eventData,
    doneCallback,
    options = {}
  ) {
    const updateLabelling = ({
      location,
      locationCode,
      response,
      description,
    }) => {
      // Update the measurement data with the labelling parameters

      if (location) {
        measurementData.location = location;
      }
      if (locationCode) {
        measurementData.locationCode = locationCode;
      }
      if (description) {
        measurementData.description = description;
      }
      if (response) {
        measurementData.response = response;
      }

      updateTableWithNewMeasurementData(measurementData);
    };

    const labellingDoneCallback = () => {
      setLabellingFlowData({ visible: false });
    };

    const labellingFlowData = {
      visible: true,
      eventData,
      measurementData,
      skipAddLabelButton: options.skipAddLabelButton,
      editLocation: options.editLocation,
      editDescription: options.editDescription,
      editResponse: options.editResponse,
      editDescriptionOnDialog: options.editDescriptionOnDialog,
      labellingDoneCallback,
      updateLabelling,
    };

    setLabellingFlowData(labellingFlowData);
  };
}

function getOnRightClickCallback(store) {
  const setToolContextMenuData = (viewportIndex, toolContextMenuData) => {
    store.dispatch(resetLabellingAndContextMenuAction());
    store.dispatch(
      setToolContextMenuDataAction(viewportIndex, toolContextMenuData)
    );
  };

  const getOnCloseCallback = viewportIndex => {
    return function onClose() {
      const toolContextMenuData = {
        visible: false,
      };

      store.dispatch(
        setToolContextMenuDataAction(viewportIndex, toolContextMenuData)
      );
    };
  };

  return function onRightClick(event) {
    const eventData = event.detail;
    const viewportIndex = parseInt(eventData.element.dataset.viewportIndex, 10);

    const toolContextMenuData = {
      eventData,
      isTouchEvent: false,
      onClose: getOnCloseCallback(viewportIndex),
    };

    setToolContextMenuData(viewportIndex, toolContextMenuData);
  };
}

function getOnMouseUpCallback(store) {
  const setToolContextMenuData = (viewportIndex, toolContextMenuData) => {
    OHIF.log.info(2);
    store.dispatch(resetLabellingAndContextMenuAction());
    store.dispatch(
      setToolContextMenuDataAction(viewportIndex, toolContextMenuData)
    );
  };

  const getOnCloseCallback = viewportIndex => {
    return function onClose() {
      const toolContextMenuData = {
        visible: false,
      };

      store.dispatch(
        setToolContextMenuDataAction(viewportIndex, toolContextMenuData)
      );
    };
  };

  return function onMouseUp(event) {
    const eventData = event.detail;
    const viewportIndex = parseInt(eventData.element.dataset.viewportIndex, 10);
    const toolContextMenuData = {
      eventData,
      isTouchEvent: false,
      onClose: getOnCloseCallback(viewportIndex),
    };
    OHIF.log.info(1);
    setToolContextMenuData(viewportIndex, toolContextMenuData);
  };
}

function getOnNewImageCallback(store) {
  return function onNewImage(event) {
    const eventData = event.detail;
    const viewportIndex = parseInt(eventData.element.dataset.viewportIndex, 10);

    store.dispatch(setImageContextDataAction(viewportIndex, eventData));
    store.dispatch(resetLabellingAndContextMenuAction());
  };
}

function getResetLabellingAndContextMenu(store) {
  return function resetLabellingAndContextMenu() {
    OHIF.log.info('resetLabellingAndContextMenu');
    store.dispatch(resetLabellingAndContextMenuAction());
  };
}

export default function setupTools(store) {
  const toolLabellingFlowCallback = getToolLabellingFlowCallback(store);
  const availableTools = [
    { name: 'Pan', mouseButtonMasks: [1, 4] },
    { name: 'Zoom', mouseButtonMasks: [1, 2] },
    { name: 'Wwwc', mouseButtonMasks: [1] },
    { name: 'Magnify', mouseButtonMasks: [1] },
    { name: 'WwwcRegion', mouseButtonMasks: [1] },
    { name: 'Heatmap', mode: 'enabled', mouseButtonMasks: [] },
    {
      name: 'Bidirectional',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    {
      name: 'Length',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    {
      name: 'Angle',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    { name: 'StackScroll', mouseButtonMasks: [1] },
    { name: 'Brush', mouseButtonMasks: [1] },
    {
      name: 'FreehandMouse',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    {
      name: 'EllipticalRoi',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    {
      name: 'CircleRoi',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    {
      name: 'RectangleRoi',
      props: {
        configuration: {
          getMeasurementLocationCallback: toolLabellingFlowCallback,
        },
      },
      mouseButtonMasks: [1],
    },
    { name: 'DragProbe', mouseButtonMasks: [1] },
    { name: 'PanMultiTouch' },
    { name: 'ZoomTouchPinch' },
    { name: 'StackScrollMouseWheel' },
    { name: 'StackScrollMultiTouch' },
  ];

  const onRightClick = getOnRightClickCallback(store);
  const onMouseUp = getOnMouseUpCallback(store);
  const onNewImage = getOnNewImageCallback(store);
  const onMouseClick = getResetLabellingAndContextMenu(store);
  const toolAction = OHIF.redux.actions.setExtensionData('cornerstone', {
    availableTools,
    onNewImage,
    onRightClick,
    onMouseClick,
    onMouseUp,
  });

  store.dispatch(toolAction);
}
